<template>
  <div class="personal-settings">
    <!-- 第一块：个人资料 -->
    <div class="personal-settings-section personal-info-section">
      <div class="personal-info-avatar-wrap">
        <!-- 头像容器 - auditStatus=1 时不显示修改按钮且禁用点击 -->
        <div 
          v-if="avatarDisplay.auditStatus !== 1" 
          class="personal-info-avatar" 
          @click="triggerAvatarUpload"
        >
          <img :src="avatarDisplay.src" alt="avatar" />
          <span v-if="!avatarDisplay.src">LOGO</span>
          <div class="personal-info-avatar-mask">
            <span>修改</span>
          </div>
        </div>
        <!-- 审核中状态 - 不可点击 -->
        <div 
          v-else 
          class="personal-info-avatar personal-info-avatar--readonly"
        >
          <img :src="avatarDisplay.src" alt="avatar" />
          <span v-if="!avatarDisplay.src">LOGO</span>
          <!-- 审核中提示（在头像内部） -->
          <div v-if="avatarDisplay.auditStatus === 1" class="personal-avatar-audit-tip">审核中</div>
        </div>
        <!-- 驳回提示 -->
        <div v-if="avatarDisplay.auditStatus === 3" class="personal-avatar-audit-tip personal-avatar-audit-tip--rejected">驳回</div>
      </div>
      <input
          ref="avatarInput"
          type="file"
          accept="image/*"
          style="display: none"
          @change="onAvatarChange"
        />
      <div class="personal-info-usercode">
        用户编号：{{ userCode }}
      </div>
      <div class="personal-settings-row">
        <span class="personal-settings-label">昵称</span>
        <span class="personal-settings-value">{{ profile.nickname }}</span>
        <span class="personal-settings-link" @click="openNicknameDialog">修改</span>
      </div>
    </div>

    <!-- 第二块：登录信息 -->
    <div class="personal-settings-section">
      <div class="personal-settings-section-title">登录信息</div>
      <div class="personal-settings-row">
        <span class="personal-settings-label">绑定手机</span>
        <span class="personal-settings-value">{{ loginInfo.mobile }}</span>
        <span class="personal-settings-link" @click="openMobileDialog">修改</span>
      </div>
      <div class="personal-settings-row">
        <span class="personal-settings-label">登录密码</span>
        <span class="personal-settings-value">{{ loginInfo.password }}</span>
        <span class="personal-settings-link" @click="openPasswordDialog">修改</span>
      </div>
    </div>

    <!-- 第三块：实名认证 -->
    <div class="personal-settings-section">
      <div class="personal-settings-section-title">
        实名认证
        <span class="personal-auth-status-tag" :class="'personal-auth-status-tag--' + authStatus">{{ authStatusText }}</span>
      </div>
      <div v-if="authStatus === 3 && auditReason" class="personal-auth-reason">
        失败原因：{{ auditReason }}
      </div>
      <div class="personal-auth-images">
        <div class="personal-auth-image-box">
          <img v-if="authInfo.idCardFront" :src="authInfo.idCardFront" alt="身份证正面" />
          <span v-else>上传身份证正面</span>
        </div>
        <div class="personal-auth-image-box">
          <img v-if="authInfo.idCardBack" :src="authInfo.idCardBack" alt="身份证国徽面" />
          <span v-else>上传身份证国徽面</span>
        </div>
      </div>
      <div class="personal-auth-info-grid">
        <div class="personal-auth-info-item">
          <span class="personal-auth-info-label">姓名</span>
          <span class="personal-auth-info-value">{{ authInfo.name }}</span>
        </div>
        <div class="personal-auth-info-item">
          <span class="personal-auth-info-label">身份证号</span>
          <span class="personal-auth-info-value">{{ authInfo.idCard }}</span>
        </div>
        <div class="personal-auth-info-item">
          <span class="personal-auth-info-label">出生日期</span>
          <span class="personal-auth-info-value">{{ authInfo.birthday }}</span>
        </div>
        <div class="personal-auth-info-item">
          <span class="personal-auth-info-label">性别</span>
          <span class="personal-auth-info-value">{{ authInfo.gender }}</span>
        </div>
        <div class="personal-auth-info-item">
          <span class="personal-auth-info-label">民族</span>
          <span class="personal-auth-info-value">{{ authInfo.nation }}</span>
        </div>
        <div class="personal-auth-info-item">
          <span class="personal-auth-info-label">证件有效期</span>
          <span class="personal-auth-info-value">{{ authInfo.validity }}</span>
        </div>
        <!-- <div class="personal-auth-info-item">
          <span class="personal-auth-info-label">住址</span>
          <span class="personal-auth-info-value">{{ authInfo.address }}</span>
        </div> -->
        <div class="personal-auth-info-item">
          <span class="personal-auth-info-label">签发单位</span>
          <span class="personal-auth-info-value">{{ authInfo.issuer }}</span>
        </div>
      </div>
      <!-- 仅当认证状态为 0(未认证) 或 3(认证失败) 时才显示修改按钮 -->
      <div v-if="authStatus === 0 || authStatus === 3" class="personal-auth-edit-row">
        <span class="personal-auth-edit-btn" @click="openAuthDialog">修改</span>
      </div>
    </div>

    <!-- 修改昵称弹窗 -->
    <van-dialog
      v-model="showNicknameDialog"
      title="修改昵称"
      show-cancel-button
      @confirm="saveNickname"
      @cancel="showNicknameDialog = false"
    >
      <div class="personal-dialog-form">
        <van-field v-model="form.nickname" label="昵称" placeholder="请输入昵称" @input="handleNicknameInput" />
      </div>
    </van-dialog>

    <!-- 修改手机号弹窗 -->
    <van-dialog
      v-model="showMobileDialog"
      title="修改手机号码"
      width="390px"
      show-cancel-button
      :before-close="saveMobile"
      @cancel="showMobileDialog = false"
    >
      <div class="personal-mobile-dialog-form">
        <div class="mobile-dialog-row">
          <span class="mobile-dialog-label">登录手机号:</span>
          <span class="mobile-dialog-value" style="margin-left: 20px;">{{ loginInfo.mobile }}</span>
        </div>
        <div class="mobile-dialog-row">
          <span class="mobile-dialog-label">更换新手机号:</span>
          <van-field
            v-model="mobileForm.newMobile"
            placeholder="请输入新手机号"
            style="width: 68%;"
            maxlength="11"
          />
        </div>
        <div class="mobile-dialog-row">
          <span class="mobile-dialog-label">确认新手机号:</span>
          <van-field
            v-model="mobileForm.confirmNewMobile"
            placeholder="请再次输入新手机号"
            style="width: 68%;"
            maxlength="11"
          />
        </div>
        <!-- 图形验证码 -->
        <div class="mobile-dialog-row">
          <span class="mobile-dialog-label">图形验证码:</span>
          <div class="mobile-dialog-code-wrapper-flexible">
            <van-field
              v-model="mobileForm.code"
              placeholder="请输入图形验证码"
              maxlength="6"
              style="width: 68%;"
            />
                    
            <!-- 图形验证码 - 缩小尺寸，确保显示完整 -->
            <div class="mobile-dialog-captcha-wrap-container">
              <div class="mobile-dialog-captcha-wrap-small" @click="refreshBindingCaptcha">
                <img v-if="bindingCaptchaUrl" :src="bindingCaptchaUrl" alt="图形验证码" style="object-fit: cover;" />
                <div v-else class="captcha-placeholder">点击获取</div>
              </div>
            </div>
          </div>
        </div>
                
        <!-- 原手机号验证码 -->
        <div class="mobile-dialog-row">
          <span class="mobile-dialog-label">原手机号验证码:</span>
          <div class="mobile-dialog-sms-wrapper-flexible">
            <van-field
              v-model="mobileForm.smsCode"
              placeholder="请输入短信验证码"
              maxlength="6"
              style="width: 68%;"
            />
            <button
              class="personal-dialog-code-btn"
              :disabled="countdown > 0"
              @click="handleSendMobileCode"
            >
              {{ countdown > 0 ? `${countdown}s` : '获取验证码' }}
            </button>
          </div>
        </div>
      </div>
    </van-dialog>

    <!-- 修改密码弹窗 -->
    <van-dialog
      v-model="showPasswordDialog"
      width="380px"
      title="修改密码"
      show-cancel-button
      :before-close="savePassword"
      @cancel="showPasswordDialog = false"
    >
      <div class="personal-dialog-form">
        <!-- 登录手机号 -->
        <div class="mobile-dialog-row">
          <span class="mobile-dialog-label">登录手机号:</span>
          <div class="mobile-dialog-value" style="margin-left: 24px;">{{ loginInfo.mobile }}</div>
        </div>
        
        <!-- 图形验证码 -->
        <div class="mobile-dialog-row">
          <span class="mobile-dialog-label">图形验证码:</span>
          <div class="mobile-dialog-code-wrapper-flexible">
            <van-field
              v-model="passwordForm.captchaInput"
              placeholder="请输入图形验证码"
              maxlength="6"
              style="width: 68%;margin-left: 11px;"
            />
            <!-- 图形验证码 - 右对齐 -->
            <div class="mobile-dialog-captcha-wrap-container">
              <div class="mobile-dialog-captcha-wrap-small">
                <img v-if="passwordCaptchaUrl" :src="passwordCaptchaUrl" alt="图形验证码" style="object-fit: cover;" />
                <div v-else class="captcha-placeholder">点击获取</div>
              </div>
            </div>
          </div>
        </div>
        
        <!-- 短信验证码 -->
        <div class="mobile-dialog-row">
          <span class="mobile-dialog-label">短信验证码:</span>
          <div class="mobile-dialog-sms-wrapper-flexible">
            <van-field
              v-model="passwordForm.smsCode"
              placeholder="请输入短信验证码"
              maxlength="6"
              style="width: 68%;margin-left: 11px;"
            />
            <button
              class="personal-dialog-code-btn"
              :disabled="passwordCountdown > 0"
              @click="handleSendPasswordCode" style="margin-left: -5px;"
            >
              {{ passwordCountdown > 0 ? `${passwordCountdown}s` : '获取验证码' }}
            </button>
          </div>
        </div>
        
        <van-field v-model="passwordForm.newPassword" label="新密码" placeholder="请输入新密码" type="password" />
        <div class="password-tip">密码长度必须大于8位，并且是复杂密码（包含大小写字母、数字、特殊符号中的至少 2 种）</div>
        <van-field v-model="passwordForm.confirmPassword" label="确认密码" placeholder="请再次输入新密码" type="password" />
      </div>
    </van-dialog>

    <!-- 修改实名认证弹窗（使用 van-popup + :value 完全控制关闭行为） -->
    <van-popup
      :value="showAuthDialog"
      :close-on-click-overlay="false"
      round
      class="personal-auth-popup"
      @input="onAuthPopupInput"
    >
      <div class="personal-auth-popup-inner">
        <div class="personal-auth-popup-header">实名认证</div>
        <div class="personal-auth-popup-body">
          <div class="personal-dialog-form personal-dialog-form--auth">
            <div class="personal-dialog-upload-row">
              <div class="personal-dialog-upload-box" @click="triggerIdCardUpload('front')">
                <img v-if="form.idCardFront" :src="form.idCardFront" alt="身份证正面" />
                <span v-else>上传身份证正面</span>
              </div>
              <div class="personal-dialog-upload-box" @click="triggerIdCardUpload('back')">
                <img v-if="form.idCardBack" :src="form.idCardBack" alt="身份证国徽面" />
                <span v-else>上传身份证国徽面</span>
              </div>
            </div>
            <input
              ref="idCardFrontInput"
              type="file"
              accept="image/*"
              style="display: none"
              @change="onIdCardChange($event, 'front')"
            />
            <input
              ref="idCardBackInput"
              type="file"
              accept="image/*"
              style="display: none"
              @change="onIdCardChange($event, 'back')"
            />
            <div class="personal-dialog-field-grid">
              <van-field v-model="form.name" label="姓名" placeholder="请输入姓名" @input="handleNameInput" />
              <van-field v-model="form.idCard" label="身份证号" placeholder="请输入身份证号" @input="handleIdCardInput" />
              <van-field
                v-model="form.birthday"
                label="出生日期"
                placeholder="请选择出生日期"
                readonly
                clickable
                @click.native="openBirthdayPicker"
              />
              <div class="personal-dialog-field personal-dialog-radio-field" @click.stop>
                <span class="personal-dialog-radio-label">性别</span>
                <van-radio-group v-model="form.gender" style="font-size: 14px;" direction="horizontal">
                  <van-radio name="男">男</van-radio>
                  <van-radio name="女">女</van-radio>
                </van-radio-group>
              </div>
              <!-- 民族选择器 -->
              <div class="personal-dialog-field personal-dialog-picker-field" @click="showNationPicker = true">
                <span class="personal-dialog-radio-label">民族</span>
                <span style="flex: 1; font-size: 14px; color: #323233;">{{ form.nation || '请选择民族' }}</span>
              </div>
              <div class="personal-dialog-field personal-dialog-placeholder"></div>
            </div>
            <div class="personal-dialog-validity-row">
              <van-field
                v-model="form.validityStart"
                label="有效期开始"
                placeholder="请选择开始日期"
                readonly
                clickable
                @click.native="openValidityStartPicker"
              />
              <van-field
                v-model="form.validityEnd"
                label="有效期结束"
                placeholder="请选择结束日期"
                readonly
                clickable
                :disabled="isLongTerm"
                @click.native="openValidityEndPicker"
              />
              <div class="personal-dialog-longterm" @click="isLongTerm = !isLongTerm">
                <span class="personal-dialog-longterm-check" :class="{ 'is-active': isLongTerm }"></span>
                <span class="personal-dialog-longterm-label">长期</span>
              </div>
            </div>
            <div class="personal-dialog-field-grid">
              <van-field v-model="form.issuer" class="personal-dialog-field-full" label="签发单位" placeholder="请输入签发单位" @input="handleIssuerInput" />
            </div>
          </div>
          <div class="auth-dialog-footer">
            <span class="auth-dialog-btn" @click="showAuthDialog = false">取消</span>
            <span class="auth-dialog-btn auth-dialog-btn-primary" @click="handleConfirmClick">确认</span>
          </div>
        </div>
      </div>
    </van-popup>

    <!-- 出生日期选择 -->
    <van-popup v-model="showBirthdayPicker" position="bottom" round>
      <van-datetime-picker
        v-model="currentPickerDate"
        type="date"
        title="选择出生日期"
        :min-date="birthdayMinDate"
        :max-date="birthdayMaxDate"
        @confirm="onBirthdayConfirm"
        @cancel="showBirthdayPicker = false"
      />
    </van-popup>

    <!-- 证件有效期开始选择 -->
    <van-popup v-model="showValidityStartPicker" position="bottom" round>
      <van-datetime-picker
        v-model="currentPickerDate"
        type="date"
        title="选择有效期开始"
        :min-date="validityMinDate"
        :max-date="validityMaxDate"
        @confirm="onValidityStartConfirm"
        @cancel="showValidityStartPicker = false"
      />
    </van-popup>

    <!-- 证件有效期结束选择 -->
    <van-popup v-model="showValidityEndPicker" position="bottom" round>
      <van-datetime-picker
        v-model="currentPickerDate"
        type="date"
        title="选择有效期结束"
        :min-date="validityMinDate"
        :max-date="validityMaxDate"
        @confirm="onValidityEndConfirm"
        @cancel="showValidityEndPicker = false"
      />
    </van-popup>

    <!-- 民族选择器 -->
    <van-popup v-model="showNationPicker" position="bottom" round>
      <div style="padding-bottom: 40px;">
        <div class="personal-nation-picker-header">
          <span class="personal-nation-picker-btn" @click="showNationPicker = false">取消</span>
          <span class="personal-nation-picker-title">请选择民族</span>
          <span class="personal-nation-picker-btn personal-nation-picker-confirm" @click="confirmNationSelect">确定</span>
        </div>
        <van-cell-group style="margin-top: 16px;"> 
          <van-field
            v-model="nationSearchKeyword"
            placeholder="输入关键字搜索民族"
            clearable
            prefix-icon="search"
          />
        </van-cell-group>
        <div class="personal-nation-picker-list">
          <div
            v-for="(nation, index) in filteredNationList"
            :key="index"
            :class="['personal-nation-item', selectedNationIndex === index ? 'is-selected' : '']"
            @click="selectedNationIndex = index"
          >
            {{ nation }}
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Toast } from 'vant'
import { fetchUserInfo, changeAvatar, changeNickname, changePhone, changePassword, sendSmsCode, submitIdInfo, uploadFile } from '../../../api'
import { request } from '../../../api/request'
import CryptoJS from 'crypto-js'
export default {
  name: 'PersonalInfo',
  data() {
    return {
      profile: {
        avatar: '',
        nickname: ''
      },
      // 新头像审核状态相关
      newAvatar: '',
      newAvatarAuditStatus: 0,
      userCode: '',
      loginInfo: {
        mobile: '',
        password: '********'
      },
      authInfo: {
        idCardFront: '',
        idCardBack: '',
        name: '',
        idCard: '',
        birthday: '',
        gender: '',
        nation: '',
        validity: '',
        issuer: ''
      },
      authStatus: 0,
      auditReason: '',
      showNicknameDialog: false,
      showMobileDialog: false,
      showPasswordDialog: false,
      showAuthDialog: false,
      countdown: 0,
      timer: null,
      // 图形验证码相关
      bindingCaptchaUrl: '',
      bindingCaptchaUuid: '',
      form: {
        nickname: '',
        mobile: '',
        password: '',
        idCardFront: '',
        idCardBack: '',
        name: '',
        idCard: '',
        birthday: '',
        gender: '',
        nation: '',
        validityStart: '',
        validityEnd: '',
        address: '',
        issuer: ''
      },
      mobileForm: {
        newMobile: '',
        confirmNewMobile: '',
        code: '',           // 图形验证码输入框
        smsCode: '',        // 短信验证码输入框
        captchaCode: '',    // 发送到后端的图形验证码
        uuid: ''            // 图形验证码 UUID
      },
      passwordForm: {
        captchaInput: '',   // 图形验证码输入框
        smsCode: '',        // 短信验证码输入框
        newPassword: '',
        confirmPassword: ''
      },
      // 密码验证码相关
      passwordCountdown: 0,
      passwordTimer: null,
      passwordCaptchaUrl: '',
      passwordCaptchaUuid: '',
      showBirthdayPicker: false,
      showValidityStartPicker: false,
      showValidityEndPicker: false,
      showNationPicker: false,
      isLongTerm: false,
      currentPickerDate: new Date(),
      birthdayMinDate: new Date(1900, 0, 1),
      birthdayMaxDate: new Date(),
      validityMinDate: new Date(1900, 0, 1),
      validityMaxDate: new Date(2100, 11, 31),
      // 民族列表（56 个民族）
      nationList: [
        '汉族', '蒙古族', '回族', '藏族', '维吾尔族', '苗族', '彝族', '壮族', '布依族', '朝鲜族',
        '满族', '侗族', '瑶族', '白族', '土家族', '哈尼族', '哈萨克族', '傣族', '黎族', '傈僳族',
        '畲族', '高山族', '拉祜族', '水族', '东乡族', '纳西族', '景颇族', '柯尔克孜族', '土族', '达斡尔族',
        '仫佬族', '羌族', '布朗族', '锡伯族', '阿昌族', '普米族', '塔吉克族', '怒族', '乌孜别克族', '俄罗斯族',
        '鄂温克族', '德昂族', '保安族', '裕固族', '京族', '塔塔尔族', '独龙族', '鄂伦春族', '赫哲族', '门巴族',
        '珞巴族', '基诺族'
      ],
      nationSearchKeyword: '',
      selectedNationIndex: -1
    }
  },
  created() {
    this.getUserInfo()
  },
  beforeDestroy() {
    this.clearTimer()
    if (this.passwordTimer) {
      clearInterval(this.passwordTimer)
      this.passwordTimer = null
    }
  },
  computed: {
    authStatusText() {
      const map = { 0: '未认证', 1: '待审核', 2: '已认证', 3: '认证失败' }
      return map[this.authStatus] || '未知'
    },
    /**
     * 过滤后的民族列表（支持搜索）
     */
    filteredNationList() {
      if (!this.nationSearchKeyword) {
        return this.nationList
      }
      return this.nationList.filter(nation => 
        nation.includes(this.nationSearchKeyword.trim())
      )
    },
    /**
     * 头像显示逻辑
     * - newAvatarAuditStatus 为 1 时显示 newAvatar（审核中）
     * - newAvatarAuditStatus 为 3 时显示 newAvatar（驳回）
     * - 其他情况显示 avatar
     */
    avatarDisplay() {
      const auditStatus = this.newAvatarAuditStatus
      let src = ''
      
      if (auditStatus === 1 || auditStatus === 3) {
        // 审核中和驳回都显示 newAvatar
        src = this.newAvatar || ''
      } else {
        // 其他情况显示原头像
        src = this.profile.avatar || ''
      }
      
      return {
        src,
        auditStatus
      }
    }
  },
  methods: {
    // 获取用户信息
    async getUserInfo() {
      try {
        const data = await fetchUserInfo()
        this.userCode = data.userCode || ''
        this.profile = {
          avatar: data.avatar || '',
          nickname: data.nickname || 'ChinaBrand'
        }
        // 新头像审核状态相关字段
        this.newAvatar = data.newAvatar || ''
        this.newAvatarAuditStatus = data.newAvatarAuditStatus || 0
        this.loginInfo = {
          mobile: data.mobile || '',
          password: data.password ? '********' : '********'
        }
        this.authStatus = data.realNameStatus || 0
        this.auditReason = data.auditReason || ''
        const validityStart = this.formatDate(data.idCardValidityStart)
        let validityEnd = this.formatDate(data.idCardValidityEnd)
        if (validityEnd === '2199-01-01') {
          validityEnd = '长期'
        }
        this.authInfo = {
          idCardFront: data.idCardFrontImage || '',
          idCardBack: data.idCardBackImage || '',
          name: data.realName || '',
          idCard: data.idCardNo || '',
          birthday: this.formatDate(data.birthday),
          gender: this.formatGender(data.gender),
          nation: data.ethnicity || '',
          validity: validityStart && validityEnd ? `${validityStart} 至 ${validityEnd}` : (validityStart || validityEnd || ''),
          address: data.idCardAddress || '',
          issuer: data.idCardIssueAuthority || ''
        }
        this.$emit('loaded')
      } catch (err) {
        Toast(err.message || '获取用户信息失败')
        this.$emit('load-error')
      }
    },
    formatDate(date) {
      if (!date) return ''
      const d = new Date(date)
      if (isNaN(d.getTime())) return String(date)
      const year = d.getFullYear()
      const month = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    formatGender(gender) {
      const map = { 0: '未知', 1: '男', 2: '女' }
      return map[gender] || '未知'
    },
    // 头像上传
    triggerAvatarUpload() {
      this.$refs.avatarInput.click()
    },
    async onAvatarChange(e) {
      const file = e.target.files[0]
      if (!file) return
      if (!file.type.startsWith('image/')) {
        Toast('请选择图片文件')
        return
      }
      try {
        const url = await uploadFile(file)
        await changeAvatar(url)
        // 上传后重新获取用户信息，更新头像审核状态
        await this.getUserInfo()
        Toast('头像上传成功')
      } catch (err) {
        Toast(err.message || '头像上传失败')
      }
    },
    async uploadFile(file) {
      return uploadFile(file)
    },
    updateLocalUserInfo() {
      try {
        const userInfoStr = localStorage.getItem('userInfo')
        const userInfo = userInfoStr ? JSON.parse(userInfoStr) : {}
        userInfo.nickname = this.profile.nickname
        userInfo.avatar = this.profile.avatar
        localStorage.setItem('userInfo', JSON.stringify(userInfo))
      } catch (e) {
        // 忽略存储异常
      }
    },
    // 昵称弹窗
    openNicknameDialog() {
      this.form.nickname = this.profile.nickname
      this.showNicknameDialog = true
    },
    /** 昵称输入长度限制（英文数字占 1 字符，汉字占 2 字符） */
    handleNicknameInput() {
      // 移除特殊字符
      const reg = /[^一-\u9fa5a-zA-Z0-9]/g
      this.form.nickname = this.form.nickname.replace(reg, '')
      // 长度限制
      this.form.nickname = this.limitCharLength(this.form.nickname, 20)
    },
    /** 按字符权重截断字符串（英文数字占 1，汉字占 2） */
    limitCharLength(str, maxLen) {
      if (!str) return str
      let len = 0
      let i = 0
      for (; i < str.length; i++) {
        const charLen = str.charCodeAt(i) > 127 ? 2 : 1
        if (len + charLen > maxLen) break
        len += charLen
      }
      return str.substring(0, i)
    },
    /** 身份证号码输入处理：仅允许 17 位数字 + 第 18 位（数字或 x/X） */
    handleIdCardInput(value) {
      // 移除所有非数字和非 x 的字符
      let cleaned = value.replace(/[^0-9axX]/g, '')
      // 如果长度超过 18，只保留前 18 位
      if (cleaned.length > 18) {
        cleaned = cleaned.substring(0, 18)
      }
      // 最后一位如果是字母，转换为小写 x
      if (cleaned.length === 18) {
        const lastChar = cleaned.charAt(17)
        if (lastChar === 'x' || lastChar === 'X') {
          cleaned = cleaned.substring(0, 17) + 'x'
        }
      }
      this.form.idCard = cleaned
    },
    /** 姓名字段输入处理：仅允许 2-20 个汉字或"·" */
    handleNameInput(value) {
      // 移除非汉字和非"·"的字符
      let cleaned = value.replace(/[^\u4e00-\u9fa5·]/g, '')
      // 限制最大长度为 20 个字符
      if (cleaned.length > 20) {
        cleaned = cleaned.substring(0, 20)
      }
      this.form.name = cleaned
    },
    /** 签发单位输入处理：仅中文输入，长度不超过 30 字节 */
    handleIssuerInput(value) {
      // 移除非中文和非"·"的字符
      let cleaned = value.replace(/[^\u4e00-\u9fa5·]/g, '')
      // 按字节计算长度，每个汉字占 2 字节，"·"也占 2 字节
      let byteLen = 0
      let validLen = 0
      for (let i = 0; i < cleaned.length; i++) {
        const charByteLen = 2 // 中文字符都是 2 字节
        if (byteLen + charByteLen > 30) break
        byteLen += charByteLen
        validLen++
      }
      if (validLen < cleaned.length) {
        cleaned = cleaned.substring(0, validLen)
      }
      this.form.issuer = cleaned
    },
    /** 民族输入处理：仅允许汉字，最多 20 个字符 */
    handleNationInput(value) {
      let cleaned = value.replace(/[^\u4e00-\u9fa5]/g, '')
      if (cleaned.length > 20) {
        cleaned = cleaned.substring(0, 20)
      }
      this.form.nation = cleaned
    },
    // 民族选择相关方法
    confirmNationSelect() {
      const selectedNation = this.filteredNationList[this.selectedNationIndex]
      if (selectedNation) {
        this.form.nation = selectedNation
      }
      this.showNationPicker = false
    },
    validateNicknameFormat(nickname) {
      const reg = /^[a-zA-Z0-9\u4e00-\u9fa5]+$/
      return reg.test(nickname)
    },
    async saveNickname() {
      const nickname = this.form.nickname.trim()
      if (!nickname) {
        Toast('昵称不能为空')
        return
      }
      if (!this.validateNicknameFormat(nickname)) {
        Toast('昵称只能包含大小写字母、数字和汉字')
        return
      }
      try {
        await changeNickname(nickname)
        this.profile.nickname = nickname
        this.updateLocalUserInfo()
        this.$emit('user-updated')
        Toast('昵称修改成功')
      } catch (err) {
        Toast(err.message || '昵称修改失败')
      }
    },
    // 修改手机号弹窗
    openMobileDialog() {
      this.mobileForm = {
        newMobile: '',
        confirmNewMobile: '',
        code: '',           // 图形验证码输入框
        smsCode: '',        // 短信验证码输入框
        captchaCode: '',    // 发送到后端的图形验证码
        uuid: ''            // 图形验证码 UUID
      }
      this.showMobileDialog = true
      this.loadBindingCaptcha()  // 打开弹窗时立即加载图形验证码
    },
    async saveMobile(action, done) {
      if (action !== 'confirm') { done(); return }
      const newMobile = this.mobileForm.newMobile.trim()
      const confirmNewMobile = this.mobileForm.confirmNewMobile.trim()
      const code = this.mobileForm.smsCode.trim()
      
      if (!newMobile) {
        Toast('请输入新手机号')
        done(false);
        return
      }
      if (!/^1[3-9]\d{9}$/.test(newMobile)) {
        Toast('请输入正确的手机号') 
        done(false);
        return
      }
      if (!confirmNewMobile) {
        Toast('请确认新手机号')
        done(false);
        return
      }
      if (newMobile !== confirmNewMobile) {
        Toast('两次输入的新手机号不一致')
        done(false);  
        return
      }
      if (!code) {
        Toast('请输入短信验证码')
        done(false);
        return
      }
      try {
        await changePhone(code, newMobile, '')
        this.loginInfo.mobile = newMobile
        done(true);
        Toast('手机号修改成功')
        this.showMobileDialog = false
      } catch (err) {
        Toast(err.message || '手机号修改失败')
        done(false);
      }
    },
    // 修改密码弹窗
    openPasswordDialog() {
      this.passwordForm = {
        captchaInput: '',   // 图形验证码输入框
        smsCode: '',        // 短信验证码输入框
        newPassword: '',
        confirmPassword: ''
      }
      this.passwordCountdown = 0
      this.showPasswordDialog = true
      this.loadPasswordCaptcha()  // 打开弹窗时立即加载图形验证码
    },
    async savePassword(action, done) {
      if (action !== 'confirm') { done(); return }
      const smsCode = this.passwordForm.smsCode.trim()
      const newPassword = this.passwordForm.newPassword
      const confirmPassword = this.passwordForm.confirmPassword
      
      if (!smsCode) {
        Toast('请输入短信验证码')
        done(false);
        return
      }
      if (!newPassword) {
        Toast('请输入新密码')
        done(false);
        return
      }
      
      // 密码验证：长度 8-20 位，且至少包含两种字符类型 (大小写字母、数字、特殊符号)
      if (newPassword.length < 8 || newPassword.length > 20) {
        Toast('密码长度必须在 8-20 个字符之间')
        done(false);
        return
      }
      
      // 检查密码复杂度
      const hasUpper = /[A-Z]/.test(newPassword)
      const hasLower = /[a-z]/.test(newPassword)
      const hasDigit = /\d/.test(newPassword)
      const hasSpecial = /[!@#$%^&*()_+=][{};':"\\|,.<>?~`-]/.test(newPassword)
      
      const typeCount = [hasUpper, hasLower, hasDigit, hasSpecial].filter(Boolean).length
      
      if (typeCount < 2) {
        Toast('密码必须包含至少两种字符类型 (大小写字母、数字、特殊符号)')
        done(false);
        return
      }
      
      if (newPassword !== confirmPassword) {
      
        Toast('两次密码输入不一致')
          done(false);
        return
      }
      
      try {
        // AES 加密密码（使用与登录页面相同的加密方法）
        const SECRET_KEY = CryptoJS.enc.Utf8.parse('zp_base_aes_2026')
        const wordArray = CryptoJS.enc.Utf8.parse(newPassword)
        const encrypted = CryptoJS.AES.encrypt(wordArray, SECRET_KEY, {
          mode: CryptoJS.mode.ECB,
          padding: CryptoJS.pad.Pkcs7
        }).toString()
        
        await changePassword(this.loginInfo.mobile, smsCode, encrypted)
        this.loginInfo.password = '********'
        Toast('密码修改成功')
        this.showPasswordDialog = false
      } catch (err) {
        Toast(err.message || '密码修改失败')
        done(false);
      }
    },
    // 发送验证码 (修改手机号时使用)
    async handleSendMobileCode() {
      if (this.countdown > 0) return
      
      // 先检查图形验证码输入框
      if (!this.mobileForm.code) {
        Toast('请输入图形验证码')
        return
      }
      console.log('发送验证码', this.mobileForm.code)
      console.log('发送验证码', this.mobileForm.code, this.mobileForm.uuid)
      try {
        await sendSmsCode(null, {  // 不传 mobile 参数
          captchaCode: this.mobileForm.code,
          uuid: this.mobileForm.uuid
        },'member')
        this.startCountdown()
        Toast('验证码已发送')
        this.loadBindingCaptcha() // 刷新图片验证码
      } catch (err) {
        Toast(err.message || '验证码发送失败')
      }
    },
    // 加载图形验证码
    loadBindingCaptcha() {
      request('/api/captchaImage')
        .then(res => {
          if (res.code === 200) {
            this.bindingCaptchaUrl = `data:image/png;base64,${res.img}`
            this.mobileForm.uuid = res.uuid
          }
        })
        .catch(err => {
          console.error('获取验证码失败:', err)
        })
    },
    // 刷新图形验证码
    refreshBindingCaptcha() {
      this.loadBindingCaptcha()
    },
    // 刷新密码图形验证码
    refreshPasswordCaptcha() {
      this.loadPasswordCaptcha()
    },
    
    // 加载密码图形验证码
    loadPasswordCaptcha() {
      request('/api/captchaImage').then(res => {
        if (res.data?.img || res.img) {
          const url = res.data?.img || res.img || ''
          const uuid = res.data?.uuid || res.uuid || ''
          if (url) {
            this.passwordCaptchaUrl = `data:image/png;base64,${url}`
            this.passwordCaptchaUuid = uuid
          }
        }
      }).catch(err => {
        console.error('获取密码验证码失败:', err)
      })
    },
    
    // 发送密码验证码
    async handleSendPasswordCode() {
      if (this.passwordCountdown > 0) return
      
      // 先检查图形验证码输入框
      if (!this.passwordForm.captchaInput) {
        Toast('请输入图形验证码')
        return
      }
      
      try {
        await sendSmsCode(null, {  // 不传 mobile 参数
          captchaCode: this.passwordForm.captchaInput,
          uuid: this.passwordCaptchaUuid
        },'member')
        this.startPasswordCountdown()
        Toast('验证码已发送')
        this.loadPasswordCaptcha() // 刷新图片验证码
      } catch (err) {
        Toast(err.message || '验证码发送失败')
      }
    },
    startCountdown() {
      this.countdown = 60
      this.timer = setInterval(() => {
        this.countdown--
        if (this.countdown <= 0) {
          clearInterval(this.timer)
          this.timer = null
        }
      }, 1000)
    },
    
    // 密码验证码倒计时
    startPasswordCountdown() {
      this.passwordCountdown = 60
      this.passwordTimer = setInterval(() => {
        this.passwordCountdown--
        if (this.passwordCountdown <= 0) {
          clearInterval(this.passwordTimer)
          this.passwordTimer = null
        }
      }, 1000)
    },
    clearTimer() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
      if (this.passwordTimer) {
        clearInterval(this.passwordTimer)
        this.passwordTimer = null
      }
    },
    // 日期选择
    parseDate(dateStr) {
      if (!dateStr || dateStr === '长期') return null
      const d = new Date(dateStr)
      return isNaN(d.getTime()) ? null : d
    },
    openBirthdayPicker() {
      this.currentPickerDate = this.parseDate(this.form.birthday) || new Date()
      this.showBirthdayPicker = true
    },
    openValidityStartPicker() {
      this.currentPickerDate = this.parseDate(this.form.validityStart) || new Date()
      this.showValidityStartPicker = true
    },
    openValidityEndPicker() {
      if (this.isLongTerm) return
      this.currentPickerDate = this.parseDate(this.form.validityEnd) || new Date()
      this.showValidityEndPicker = true
    },
    onBirthdayConfirm(value) {
      this.form.birthday = this.formatDate(value)
      this.showBirthdayPicker = false
    },
    onValidityStartConfirm(value) {
      this.form.validityStart = this.formatDate(value)
      this.showValidityStartPicker = false
    },
    onValidityEndConfirm(value) {
      this.form.validityEnd = this.formatDate(value)
      this.isLongTerm = false
      this.showValidityEndPicker = false
    },
    // 实名认证弹窗
    openAuthDialog() {
      const validityParts = String(this.authInfo.validity || '').split('至').map(s => s.trim())
      const validityStart = validityParts[0] || ''
      let validityEnd = validityParts[1] || ''
      const isLongTerm = validityEnd === '长期' || validityEnd === '2199-01-01' || this.authInfo.validity === '长期'
      if (isLongTerm) {
        validityEnd = '长期'
      }
      this.isLongTerm = isLongTerm
      this.form = {
        ...this.form,
        ...this.authInfo,
        validityStart,
        validityEnd,
        mobile: this.loginInfo.mobile,
        password: this.loginInfo.password,
        nickname: this.profile.nickname
      }
      this.showAuthDialog = true
    },
    // 拦截 popup 内部所有关闭尝试（不做任何操作，弹窗只在我们显式设置 showAuthDialog=false 时才关闭）
    onAuthPopupInput() {},
    // 处理确认按钮点击
    handleConfirmClick() {
      this.saveAuthInfo()
    },
    async saveAuthInfo() {
      // 验证姓名格式
      if (!this.form.name || !String(this.form.name).trim()) {
        Toast('请输入姓名')
        return
      }
      const nameReg = /^[{\u4e00-\u9fa5·}]{2,20}$/
      if (!nameReg.test(this.form.name)) {
        Toast('姓名应为 2-20 个汉字或"·"')
        return
      }
      
      // 验证身份证号格式
      if (!this.form.idCard || !String(this.form.idCard).trim()) {
        Toast('请输入身份证号')
        return
      }
      if (this.form.idCard.length !== 18) {
        Toast('身份证号应为 18 位')
        return
      }
      const idCardReg = /^[0-9]{17}[0-9xX]$/
      if (!idCardReg.test(this.form.idCard)) {
        Toast('身份证号格式不正确')
        return
      }
      
      // 验证出生日期
      if (!this.form.birthday || !String(this.form.birthday).trim()) {
        Toast('请选择出生日期')
        return
      }
      
      // 特别验证性别必须选择
      if (!this.form.gender || !['男', '女'].includes(this.form.gender)) {
        Toast('请选择性别')
        return
      }
      
      // 验证民族
      if (!this.form.nation || !String(this.form.nation).trim()) {
        Toast('请输入民族')
        return
      }
      
      // 验证有效期开始日期
      if (!this.form.validityStart || !String(this.form.validityStart).trim()) {
        Toast('请选择证件有效期开始日期')
        return
      }
      
      // 验证有效期结束日期或长期选项
      if (!this.isLongTerm && !this.form.validityEnd) {
        Toast('请选择证件有效期结束日期或选择长期')
        return
      }
      
      // 验证签发单位
      if (!this.form.issuer || !String(this.form.issuer).trim()) {
        Toast('请输入签发单位')
        return
      }
      const longTermDate = '2199-01-01'
      const displayValidityEnd = this.isLongTerm ? '长期' : this.form.validityEnd
      const idCardValidityEnd = this.isLongTerm ? longTermDate : this.form.validityEnd
      const genderMap = { '未知': 0, '男': 1, '女': 2 }
      const params = {
        realName: this.form.name,
        idCardNo: this.form.idCard,
        idCardFrontImage: this.form.idCardFront,
        idCardBackImage: this.form.idCardBack,
        ethnicity: this.form.nation,
        idCardIssueAuthority: this.form.issuer,
        idCardValidityStart: this.form.validityStart,
        idCardValidityEnd,
        gender: genderMap[this.form.gender] !== undefined ? genderMap[this.form.gender] : 0,
        birthday: this.form.birthday
      }
      try {
        await submitIdInfo(params)
        this.authInfo = {
          idCardFront: this.form.idCardFront,
          idCardBack: this.form.idCardBack,
          name: this.form.name,
          idCard: this.form.idCard,
          birthday: this.form.birthday,
          gender: this.form.gender,
          nation: this.form.nation,
          validity: `${this.form.validityStart} 至 ${displayValidityEnd}`,
          issuer: this.form.issuer
        }
        this.authStatus = 1
        Toast('实名认证信息提交成功')
        this.showAuthDialog = false
      } catch (err) {
        Toast(err.message || '实名认证信息提交失败')
        // 接口调用失败保持弹窗打开
      }
    },
    // 身份证上传
    triggerIdCardUpload(type) {
      const ref = type === 'front' ? 'idCardFrontInput' : 'idCardBackInput'
      this.$refs[ref].click()
    },
    async onIdCardChange(e, type) {
      const file = e.target.files[0]
      if (!file) return
      if (!file.type.startsWith('image/')) {
        Toast('请选择图片文件')
        return
      }
      try {
        const url = await this.uploadFile(file)
        const key = type === 'front' ? 'idCardFront' : 'idCardBack'
        this.form[key] = url
      } catch (err) {
        Toast(err.message || '图片上传失败')
      }
    }
  }
}
</script>

<style scoped>
.personal-info-section {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.personal-info-avatar-wrap {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
  position: relative;
}

.personal-info-avatar {
  position: relative;
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background: #F5FAFF;
  border: 1px solid #E4F2FF;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #B2B2B2;
  overflow: hidden;
  cursor: pointer;
}

/* 只读模式（审核中）- 无点击效果 */
.personal-info-avatar--readonly {
  cursor: default;
}

.personal-info-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.personal-info-avatar-mask {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.personal-info-avatar:hover .personal-info-avatar-mask {
  opacity: 1;
}

.personal-info-avatar-mask span {
  color: #FFFFFF;
  font-size: 14px;
}

/* 头像审核状态提示 */
.personal-avatar-audit-tip {
  position: absolute;
  top: 8px;
  left: 50%;
  transform: translateX(-50%);
  padding: 2px 10px;
  border-radius: 3px;
  font-size: 14px;
  line-height: 1.4;
  white-space: nowrap;
  pointer-events: none;
  z-index: 10;
}

/* 审核中 - 蓝色 */
.personal-avatar-audit-tip:not(.personal-avatar-audit-tip--rejected) {
  background: #E1F3F8;
  color: #23B4DC;
}

/* 驳回 - 红色 */
.personal-avatar-audit-tip--rejected {
  background: #FFF1F0;
  color: #FF4D4F;
}

.personal-info-usercode {
  font-size: 13px;
  color: #999999;
  margin-bottom: 12px;
  text-align: center;
}

.personal-auth-images {
  display: flex;
  gap: 20px;
  margin-bottom: 16px;
}

.personal-auth-image-box {
  width: 220px;
  height: 140px;
  background: #F5FAFF;
  border: 1px solid #E4F2FF;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #B2B2B2;
  font-size: 13px;
  overflow: hidden;
}

.personal-auth-image-box img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.personal-auth-edit-row {
  display: flex;
  justify-content: center;
  padding-top: 16px;
  border-top: 1px solid #E4F2FF;
  margin-top: 16px;
}

.personal-auth-edit-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 28px;
  padding: 0 22px;
  background: #0084E7;
  color: #FFFFFF;
  font-size: 12px;
  border-radius: 14px;
  cursor: pointer;
  transition: opacity 0.2s ease;
}

.personal-auth-edit-btn:hover {
  opacity: 0.85;
}

.personal-auth-info-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px 24px;
}

.personal-auth-info-item {
  display: flex;
  align-items: center;
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-size: 13px;
  min-width: 0;
}

.personal-auth-info-label {
  color: #666666;
  width: 80px;
  flex-shrink: 0;
}

.personal-auth-info-value {
  color: #333333;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.personal-dialog-form {
  padding: 16px 20px;
}

.password-tip {
  font-size: 12px;
  color: #999999;
  line-height: 1.4;
}

.personal-dialog-upload-row {
  display: flex;
  gap: 16px;
  margin-bottom: 16px;
}

.personal-dialog-upload-box {
  flex: 1;
  height: 100px;
  background: #F5FAFF;
  border: 1px solid #E4F2FF;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #B2B2B2;
  font-size: 13px;
  cursor: pointer;
  overflow: hidden;
}

.personal-dialog-upload-box img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.personal-dialog-upload-box span {
  pointer-events: none;
}

/* 实名认证失败原因 */
.personal-auth-reason {
  margin-bottom: 12px;
  padding: 8px 12px;
  background: #FFF1F0;
  border: 1px solid #FFCCC7;
  border-radius: 4px;
  color: #FF4D4F;
  font-size: 13px;
  line-height: 1.5;
}

/* 实名认证状态标签 */
.personal-auth-status-tag {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 22px;
  padding: 0 10px;
  margin-left: 10px;
  border-radius: 11px;
  font-size: 12px;
  font-weight: 400;
  vertical-align: middle;
}

.personal-auth-status-tag--0 {
  background: #F5F5F5;
  color: #999999;
}

.personal-auth-status-tag--1 {
  background: #FFF7E6;
  color: #FAAD14;
}

.personal-auth-status-tag--2 {
  background: #F6FFED;
  color: #52C41A;
}

.personal-auth-status-tag--3 {
  background: #FFF1F0;
  color: #FF4D4F;
}
</style>

<style>
/* 实名认证弹窗（van-popup 实现） */
.personal-auth-popup {
  width: 600px;
  max-width: 90vw;
}

.personal-auth-popup-inner {
  display: flex;
  flex-direction: column;
  max-height: 70vh;
}

.personal-auth-popup-header {
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  color: #323233;
  padding: 16px 28px;
  border-bottom: 1px solid #EBEDF0;
  flex-shrink: 0;
}

.personal-auth-popup-body {
  overflow-y: auto;
  flex: 1;
  min-height: 0;
}

/* 自定义底部按钮 */
.auth-dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 12px 28px;
  border-top: 1px solid #EBEDF0;
}

.auth-dialog-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  padding: 0 20px;
  border-radius: 18px;
  font-size: 14px;
  cursor: pointer;
  user-select: none;
  border: 1px solid #DCDEE0;
  color: #323233;
  background: #FFFFFF;
  transition: opacity 0.2s ease;
}

.auth-dialog-btn:hover {
  opacity: 0.85;
}

.auth-dialog-btn-primary {
  background: #0084E7;
  color: #FFFFFF;
  border-color: #0084E7;
}

/* 修改手机号弹窗样式 */
.personal-mobile-dialog-form {
  padding: 20px 28px;
}

.mobile-dialog-row {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  margin-left: -22px;
}

.mobile-dialog-label {
  width: 110px;
  font-size: 14px;
  color: #323233;
  text-align: right;
  flex-shrink: 0;
}

.mobile-dialog-value {
  width: calc(100% - 110px);
  font-size: 14px;
  color: #323233;
}

/* 图形验证码行 */
.mobile-dialog-code-wrapper-flexible {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 6px;  /* 减小间距 */
}

/* 清除 Vant Input 的所有样式 */
.mobile-dialog-code-wrapper-flexible .van-cell__wrapper {
  padding: 8px !important;
  background: transparent !important;
  border: none !important;
}

.mobile-dialog-code-wrapper-flexible .van-field__control input {
  padding-left: 0 !important;  /* 输入框本身不留内边距 */
  border: none !important;
  outline: none !important;
}

.mobile-dialog-code-wrapper-flexible .van-cell {
  border-left: none !important;   /* 强制去除左边框 */
  border: none !important;        /* 清除所有边框 */
}

/* 图形验证码容器 - 右对齐 */
.mobile-dialog-captcha-wrap-container {
  flex-shrink: 0;
  margin-left: auto;  /* 右对齐 */
}

/* 图形验证码 - 正常大小 */
.mobile-dialog-captcha-wrap {
  width: 60px;   /* 缩小尺寸确保能显示 */
  height: 35px;
  border-radius: 3px;
  overflow: hidden;
  cursor: pointer;
  background: #F5F5F5;
}

.mobile-dialog-captcha-wrap img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.captcha-placeholder {
  font-size: 10px;
  color: #666666;
  text-align: center;
  line-height: 35px;
}

/* 图形验证码 - 缩小尺寸 (备用) */
.mobile-dialog-captcha-wrap-small {
  width: 60px;
  height: 35px;
  border-radius: 3px;
  overflow: hidden;
  cursor: pointer;
  background: #F5F5F5;
}

.mobile-dialog-captcha-wrap-small img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* 实名认证弹窗内容样式 */
.personal-auth-popup .personal-dialog-form--auth {
  padding: 20px 28px;
}

.personal-auth-popup .personal-dialog-upload-row {
  gap: 24px;
}

.personal-auth-popup .personal-dialog-upload-box {
  height: 140px;
}

.personal-auth-popup .personal-dialog-field-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px 16px;
}

.personal-auth-popup .personal-dialog-field-grid .van-field {
  margin: 0;
}

.personal-auth-popup .personal-dialog-field-grid .van-field__label {
  width: 80px;
}

.personal-auth-popup .personal-dialog-field-grid .personal-dialog-field-full {
  grid-column: 1 / -1;
}

/* 弹窗验证码输入行 */
.personal-dialog-code-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.personal-dialog-code-row .van-field {
  flex: 1;
  margin: 0;
}

.personal-dialog-code-btn {
  flex-shrink: 0;
  height: 34px;
  padding: 0 14px;
  border: none;
  border-radius: 17px;
  background-color: rgba(35, 180, 220, 0.1);
  color: #23B4DC;
  font-size: 13px;
  cursor: pointer;
  transition: background-color 0.2s ease, color 0.2s ease;
  white-space: nowrap;
}

.personal-dialog-code-btn:hover:not(:disabled) {
  background-color: rgba(35, 180, 220, 0.18);
}

.personal-dialog-code-btn:disabled {
  color: rgba(150, 150, 150, 1);
  background-color: rgba(200, 200, 200, 0.15);
  cursor: not-allowed;
}

/* 原手机号验证码行 */
.mobile-dialog-sms-wrapper-flexible {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 4px;  /* 进一步减小间距 */
}

/* 清除 Vant Input 的所有样式 */
.mobile-dialog-sms-wrapper-flexible .van-cell__wrapper {
  padding: 8px !important;
  background: transparent !important;
  border: none !important;
}

.mobile-dialog-sms-wrapper-flexible .van-field__control input {
  padding-left: 0 !important;  /* 输入框本身不留内边距 */
  border: none !important;
  outline: none !important;
}

.mobile-dialog-sms-wrapper-flexible .van-cell {
  border-left: none !important;   /* 强制去除左边框 */
  border: none !important;        /* 清除所有边框 */
}

.personal-dialog-code-btn {
  flex-shrink: 0;
  height: 34px;
  padding: 0 12px;  /* 减小内边距 */
  border: none;
  border-radius: 17px;
  background-color: rgba(35, 180, 220, 0.1);
  color: #23B4DC;
  font-size: 13px;
  cursor: pointer;
  transition: background-color 0.2s ease, color 0.2s ease;
  white-space: nowrap;
}

.personal-dialog-code-btn:hover:not(:disabled) {
  background-color: rgba(35, 180, 220, 0.18);
}

.personal-dialog-code-btn:disabled {
  color: rgba(150, 150, 150, 1);
  background-color: rgba(200, 200, 200, 0.15);
  cursor: not-allowed;
}
.personal-auth-popup .personal-dialog-field-grid .van-field,
.personal-auth-popup .personal-dialog-radio-field {
  background: #FFFFFF;
}

.personal-auth-popup .personal-dialog-radio-field {
  display: flex;
  align-items: center;
  min-height: 44px;
  padding: 0 16px;
  box-sizing: border-box;
}

.personal-auth-popup .personal-dialog-radio-label {
  width: 80px;
  color: #646566;
  font-size: 14px;
  flex-shrink: 0;
}

.personal-auth-popup .personal-dialog-placeholder {
  visibility: hidden;
}

.personal-auth-popup .personal-dialog-validity-row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 12px;
}

.personal-auth-popup .personal-dialog-validity-row .van-field {
  flex: 1;
  margin: 0;
  min-width: 0;
}

.personal-auth-popup .personal-dialog-longterm {
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  flex-shrink: 0;
  user-select: none;
}

.personal-auth-popup .personal-dialog-longterm-check {
  width: 16px;
  height: 16px;
  border: 1px solid #C8C9CC;
  border-radius: 3px;
  background: #FFFFFF;
  position: relative;
  transition: all 0.2s ease;
}

.personal-auth-popup .personal-dialog-longterm-check.is-active {
  background: #1989FA;
  border-color: #1989FA;
}

.personal-auth-popup .personal-dialog-longterm-check.is-active::after {
  content: '';
  position: absolute;
  top: 2px;
  left: 5px;
  width: 4px;
  height: 8px;
  border: solid #FFFFFF;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.personal-auth-popup .personal-dialog-longterm-label {
  font-size: 14px;
  color: #323233;
}

/* 民族选择器样式 */
.personal-dialog-picker-field {
  display: flex;
  align-items: center;
  min-height: 44px;
  padding: 0 16px;
  cursor: pointer;
}

.personal-nation-picker-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #EBEDF0;
}

.personal-nation-picker-title {
  font-size: 16px;
  font-weight: 500;
  color: #323233;
}

.personal-nation-picker-btn {
  font-size: 14px;
  color: #1989FA;
  cursor: pointer;
}

.personal-nation-picker-btn:hover {
  opacity: 0.8;
}

.personal-nation-picker-confirm {
  font-weight: 500;
}

.personal-nation-picker-list {
  max-height: 300px;
  overflow-y: auto;
  padding: 8px;
}

.personal-nation-item {
  padding: 12px 16px;
  font-size: 14px;
  color: #323233;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.personal-nation-item:hover {
  background-color: #F5F7FA;
}

.personal-nation-item:active {
  background-color: #E8EEF7;
}

/* 选中的民族 */
.personal-nation-item.is-selected {
  background-color: #E1F3F8;
  color: #23B4DC;
  font-weight: 500;
}
</style>
